<template>
  <div class="paymentChoun" :class="isRejoin ? 'paymentChoun--rejoin' : 'paymentChoun--join'">
    <app-loading class="loading--lock" :isLoading="lock" />
    <base-title text="今日の運勢を購入する" />
    <div class="paymentChoun__head">
      <attention-choun v-if="updatePaymentError.error_message" :text="updatePaymentError.error_message"/>
      <fortune-item
        v-if="menuArray"
        :image-path="menuArray.teller_image_url"
        :title="menuArray.menu_title"
        :payment-status="isRejoin ? chounUser.status : 0"
      />
    </div>
    <dl class="paymentChoun__dl">
      <dt>価格（月額）</dt>
      <dd>¥{{ menuArray.price }}<small>(税込)</small></dd>
    </dl>
    <div class="paymentChoun__subheading">お支払い方法選択</div>
    <form-radio
      name="payment_method"
      :options="paymentMethodOption"
      :value="selectPaymentMethod"
      @change="value => selectPaymentMethod = value"
    />
    <!-- クレカ -->
    <transition>
      <div v-show="selectPaymentMethod === 'credit'">
        <app-loading v-if="isLoading" class="loading--card" :isLoading="isLoading" />
        <template v-else>
          <!-- クレカ登録&お支払い -->
          <template v-if="showNewCreditRegist">
            <div class="paymentChoun__form">
              <p class="town-card__img">
                <img width="160" src="https://websmart.zappallas.com/web_image?url=http%3A%2F%2Fwebpayment.smart-srv%2Fimage%3Fid%3D11315" alt="card">
              </p>
              <form-credit-card
                label="カード番号"
                name="cc_number"
                data-vv-name="cc_number"
                data-vv-value-path="formattedValue"
                placeholder="例）1234 5678 9123 1234"
                v-model="ccNumber"
                :validation="{ rules: {
                  required: true,
                  credit_card: true
                } }"
              />
              <form-credit-expire
                name=""
                label="カード有効期限"
                month-name="cc_expiration_m"
                year-name="cc_expiration_y"
                :validation="{ rules: {
                  required: true
                } }"
                v-model="ccExpiration"
              />
              <form-security-code v-model="securityCode" />
            </div>
          </template>
          <!-- 登録済みクレカでお支払い -->
          <template v-else>
            <div class="paymentChoun__subheading">ご登録済みお支払い情報</div>
            <card-info
              :card-number="card.number"
              :card-expiration="card.expiration"
            />
            <next-button label="クレジットカード情報を変更する" @clicked="anotherCard"/>
          </template>
          <foot-notice :menu-title="menuArray.menu_title" />
          <div class="paymentChoun__button">
            <base-button-choun
              :is-disabled="buttonIsDisabled || lock"
              :label="isRejoin ? '購入を再開する' : '購入する'"
              @clicked="showNewCreditRegist ? registCardData() : updateCardData()"
            />
          </div>
        </template>
      </div>
    </transition>
    <!-- アマゾン -->
    <transition>
      <div v-show="selectPaymentMethod === 'amazonpay'">
        <div class="paymentChoun__amazonpay">
          <amazon-pay-button :render='amazonPayArray' />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { PAYEE } from '@/CONSTS/'
// 占いTV　共通のやつ
import AmazonPayButton from '../Payment/AmazonPayButton'
import CardInfo from '../partials/CardInfo'
import NextButton from '../common/NextButton'
// 超運ダイアリー独自のやつ
import BaseTitle from './partials/BaseTitle'
import AttentionChoun from './partials/AttentionChoun'
import FormRadio from './partials/FormRadio'
import FortuneItem from './partials/FortuneItem'
import BaseButtonChoun from './partials/BaseButtonChoun'
import getChounEnvDomain from '@/utils/getChounEnvDomain'
import FootNotice from './partials/FootNotice'

export default {
  name: 'PaymentChounRegistForm',
  components:{
    AmazonPayButton,
    CardInfo,
    NextButton,
    BaseTitle,
    AttentionChoun,
    BaseButtonChoun,
    FortuneItem,
    FormRadio,
    FootNotice,
  },
  data() {
    return {
      // クレジットカード番号
      ccNumber: '',
      // クレカ 有効期限
      ccExpiration: '',
      // クレカ セキュリティーコード
      securityCode: '',
      updatePaymentError: {},
      // 新規クレカ登録画面を表示するか
      showNewCreditRegist: true,
      // 登録済みクレカ情報を取得中かどうかに使用
      isLoading: false,
      validateFlags: {},
      buttonIsDisabled: true,
      // 支払い方法の切り替え
      selectPaymentMethod: 'amazonpay',
      // 支払い方法の切り替えのデータ
      paymentMethodOption: [
        { value: 'amazonpay', text: 'Amazon Pay' },
        { value: 'credit', text: 'クレジットカード' },
      ],
      // submit 二重押下防止に使用
      lock: false,
    }
  },
  props: {
    merchantId: {
      type:String,
      default:''
    },
    serviceId: {
      type:String,
      default:''
    },
    action: {
      type:String,
      default:''
    },
    token: {
      type:String,
      default:''
    },
    // 商品メニューデータ
    menuArray: {
      type: Object,
      default() {
        return {}
      }
    },
    // Amazon Pay ボタン生成データ
    amazonPayArray: {
      type: Object,
      default() {
        return {}
      }
    },
    diaryToken: {
      type: String,
      default: ''
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    chounUser: {
      type: Object,
      default() {
        return {}
      }
    },
    isRejoin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card,
      userInfo: state => state.account.user,
    }),
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    this.isLoading = true
    if (this.isLoggedIn) this.getPaymentInfo()

    if (this.chounUser.payee === PAYEE.AMAZONPAY_CODE) { this.selectPaymentMethod = 'amazonpay' }
    else if (this.chounUser.payee === PAYEE.CREDIT_CODE) { this.selectPaymentMethod = 'credit' }
  },
  beforeDestroy() {
    this.lock = false
  },
  watch:{
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    },
    isLoggedIn(isLogin){
      if(isLogin) this.getPaymentInfo()
    }
  },
  methods: {
    anotherCard(){
      this.showNewCreditRegist = true
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        this.validateFlags = this.$validator.flags
      })
    },
    getPaymentInfo() {
      if (this.isLoggedIn && this.accessToken) {
        //カード情報取得
        this.$store.dispatch(type.GET_PAYMENT_INFO, { access_token: this.accessToken, is_choun: 1 })
        .then(()=> {
          this.showNewCreditRegist = false
        })
        .catch((err)=> console.log('card-unregistered!'))
        .finally(()=>{
          this.isLoading = false
          this.$nextTick(() => {
            this.validateFlags = this.$validator.flags
          })
        })
      }
    },
    isValid() {
      if (!this.ccNumber || this.securityCode.length <= 2 || !this.ccExpiration.month || !this.ccExpiration.year || !!this.$validator.errors.items.length) {
        this.updatePaymentError = { error_message: '入力されていない項目があります。' }
        window.scrollTo(0, 0)
        this.lock = false
        return false
      }
      this.updatePaymentError = {}
      return true
    },
    // クレカ情報更新
    updateCardData() {
      this.lock = true
      window.scrollTo(0, 0)
      //カード登録済みの場合
      const data = {
        access_token: this.accessToken,
        diary_token: this.diaryToken,
        token: '',
        tokenKey: '',
        user_id: this.userInfo.id,
        menu_id: this.menuArray.menu_id,
        is_choun: 1
      }
      this.subscStart(data)
    },
    // クレカ情報登録
    registCardData() {
      if (!this.isValid()) return
      if (!window.com_sbps_system) throw new Error('Error: window.com_sbps_system がありません。')
      this.lock = true
      window.scrollTo(0, 0)
      const data = {
        merchantId: this.merchantId,
        serviceId: this.serviceId,
        ccNumber: this.ccNumber,
        ccExpiration: `20${this.ccExpiration.year}${
          this.ccExpiration.month
        }`,
        securityCode: this.securityCode,
      }
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.updatePaymentError = {}
        const { tokenResponse } = response
        const data = {
          access_token: this.accessToken,
          diary_token: this.diaryToken,
          token: tokenResponse.token,
          tokenKey: tokenResponse.tokenKey,
          user_id: this.userInfo.id,
          menu_id: this.menuArray.menu_id,
          is_choun: 1,
        }
        this.subscStart(data)
      } else {
        window.scrollTo(0, 0);
        this.updatePaymentError =  {
          error_message: '入力内容に誤りがあります。登録するクレジットカードをご確認の上、再度入力を行ってください。'
        }
        this.lock = false
      }
    },
    //超運ダイアリー開始
    subscStart(data){
      const api = this.isRejoin ? type.UPDATE_PAYMENT_INFO_CHOUN_REJOIN : type.UPDATE_PAYMENT_INFO_CHOUN
      const transition = this.isRejoin ? `${getChounEnvDomain()}/payment/history` : '/cd/complete_join'

      this.$store.dispatch(api, data).then(() => {
        window.location.href = transition
      })
      .catch((err)=>{
        window.scrollTo(0, 0);
        this.updatePaymentError =  {
          error_message:`${err.error_title} ${err.error_message} エラーコード:${err.error_code}`
        }
        this.lock = false
      })
    },
  }
}</script>

<style lang="scss" scoped>
.paymentChoun {
  color: #4F4F4F;
  background: #fff;
  padding: 0 0 40px;
  max-width: 580px;
  margin: auto;
  &__head {
    padding: 24px 0 32px;
  }
  .attention {
    margin: 0 20px 32px;
  }
  &--join .fortuneItem /deep/ .right {
    justify-content: center !important;
  }
  &__dl {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    border-top: 1px solid #E3D6CA;
    > dt,
    > dd {
      border-bottom: 1px solid #E3D6CA;
      padding: 15px 16px 11px;
      line-height: 16px;
    }
    > dt {
      flex: 1 1 40%;
    }
    > dd {
      flex: 1 1 60%;
      margin: 0;
      text-align: right;
      color: #FF4438;
      font-size: 18px;
      font-weight: bold;
      small {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
  &__subheading {
    background: #FFF7CF;
    font-size: 12px;
    line-height: 1;
    padding: 10px 12px;
  }
  .formRadio {
    padding: 24px 30px;
    margin-bottom: 0;
    /deep/ {
      .radioArea {
        display: block;
      }
      .wrap {
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &__form {
    padding: 0 30px;
    margin: 0 auto 38px;
    .town-card__img {
      margin: 0 0 20px;
      img {
        vertical-align: middle;
      }
    }
  }
  .cardInfo {
    padding: 15px 30px;
    border-bottom: 1px solid #E3D6CA;
  }
  .nextButton {
    padding: 13px 20px 12px;
    border-bottom: 1px solid #E3D6CA;
    margin-bottom: 33px;
    justify-content: space-between;
  }
  &__button {
    padding: 0 30px;
    max-width: 375px;
    margin: 0 auto;
  }
  &__amazonpay {
    max-width: 233px;
    margin: 2px auto 0;
  }
}

.loading {
  &--lock {
    position: fixed;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &--card {
    margin: 20px auto;
  }
}
.v-enter-active {
  transition: all 200ms ease-out 0s;
}
.v-enter {
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/PaymentChounRegistForm.vue